import React, { Children } from 'react';
import { useTranslation } from 'react-i18next';
import { ArrowLeftIcon } from 'lucide-react';
import { formatCurrencyAmount } from '../../../theme/tokens';
export function ReservationDetail() {
  const {
    t
  } = useTranslation('rooms');
  const reservation = {
    pnr: 'FRU91DGE',
    status: 'confirmed',
    date: {
      checkIn: '10 May 2026',
      checkOut: '11 May 2026',
      nights: 1
    },
    guests: {
      adults: 2,
      children: 0,
      infants: 0,
      rooms: 1
    },
    booking: {
      id: '68d67b3d2e37218960b356f',
      transactionId: '68d67b3dd025cb0f2d99f912'
    },
    hotel: {
      name: 'BML Paradise Shores Resort',
      id: '689eeaf67b0e1e34cf4940b8'
    },
    room: {
      name: 'Premium Overwater Villa',
      view: 'SEA_VIEW',
      category: 'OVERWATER_VILLA'
    },
    guest: {
      name: 'Ahmed Waheed',
      email: 'sujau@bml.com.mv',
      phone: '+9607908663',
      passport: 'saaa',
      dateOfBirth: '25 Feb 2017',
      nationality: 'MDV',
      specialRequests: ''
    },
    rate: {
      name: 'Advance Booking with Free Seaplan Transfer',
      description: 'Plan your Langkawi escape early and enjoy the added luxury of a complimentary round-trip ferry transfer from Kuala Kedah to the resort. This exclusive offer rewards advance planners with both value and convenience, ensuring your journey is as seamless as your stay. Book 14 days in advance.'
    },
    price: {
      subtotal: formatCurrencyAmount(1.0, {
        fractionDigits: 2
      }),
      serviceCharge: formatCurrencyAmount(0.1, {
        fractionDigits: 2
      })
    }
  };
  const navigateBack = () => {
    window.location.href = '/reservations';
  };
  return <div className="space-y-6" data-id="element-10435">
      {/* Header with back button */}
      <div className="flex items-center space-x-2" data-id="element-10436">
        <button onClick={navigateBack} className="flex items-center text-gray-600 hover:text-gray-900" data-id="element-10437">
          <ArrowLeftIcon size={18} className="mr-1" data-id="element-10438" />
          <span data-id="element-10439">{t('pages.ReservationDetail.reservation_details')}</span>
        </button>
      </div>
      {/* Reservation Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 shadow-sm overflow-hidden" data-id="element-10440">
        {/* Reservation Header */}
        <div className="p-6 border-b border-gray-200" data-id="element-10441">
          <div className="flex justify-between items-center" data-id="element-10442">
            <h2 className="text-xl font-bold" data-id="element-10443">{reservation.pnr}</h2>
            <div className="flex space-x-4" data-id="element-10444">
              <span className="px-3 py-1 bg-green-100 text-green-800 text-sm font-semibold rounded-full" data-id="element-10445">
                {t('pages.ReservationDetail.confirmed')}
              </span>
              <button className="px-4 py-2 border border-red-500 text-red-500 rounded-md hover:bg-red-50" data-id="element-10446">
                {t('pages.ReservationDetail.resend_confirmation_email')}
              </button>
            </div>
          </div>
        </div>
        {/* Reservation Overview */}
        <div className="grid grid-cols-1 md:grid-cols-2 border-b border-gray-200" data-id="element-10447">
          <div className="p-6 border-r border-gray-200" data-id="element-10448">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-10449">
              {t('pages.ReservationDetail.date')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-10450">
              {reservation.date.checkIn} - {reservation.date.checkOut}
            </p>
            <p className="text-sm text-gray-500" data-id="element-10451">
              {reservation.date.nights} {t('pages.ReservationDetail.nights')}
            </p>
          </div>
          <div className="p-6" data-id="element-10452">
            <h3 className="text-sm font-medium text-gray-500 mb-2" data-id="element-10453">
              {t('pages.ReservationDetail.guests_rooms')}
            </h3>
            <p className="text-gray-900 font-medium" data-id="element-10454">
              {reservation.guests.adults} {t('pages.ReservationDetail.adults')}{' '}
              {reservation.guests.children}{' '}
              {t('pages.ReservationDetail.children')}{' '}
              {reservation.guests.infants}{' '}
              {t('pages.ReservationDetail.infants')}
            </p>
            <p className="text-sm text-gray-500" data-id="element-10455">
              {reservation.guests.rooms} {t('pages.ReservationDetail.room')}
            </p>
          </div>
        </div>
        {/* Booking Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10456">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10457">
            {t('pages.ReservationDetail.booking_information')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10458">
            <div data-id="element-10459">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10460">
                {t('pages.ReservationDetail.booking_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10461">{reservation.booking.id}</p>
            </div>
            <div data-id="element-10462">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10463">
                {t('pages.ReservationDetail.transaction_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10464">
                {reservation.booking.transactionId}
              </p>
            </div>
          </div>
        </div>
        {/* Hotel Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10465">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10466">
            {t('pages.PropertyInformation.hotel')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10467">
            <div data-id="element-10468">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10469">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10470">{reservation.hotel.name}</p>
            </div>
            <div data-id="element-10471">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10472">
                {t('pages.ReservationDetail.hotel_id')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10473">{reservation.hotel.id}</p>
            </div>
          </div>
        </div>
        {/* Room Type Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10474">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10475">
            {t('pages.Rates.room_type')}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-10476">
            <div data-id="element-10477">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10478">
                {t('pages.ReservationDetail.name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10479">{reservation.room.name}</p>
            </div>
            <div data-id="element-10480">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10481">
                {t('pages.ReservationDetail.view')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10482">{reservation.room.view}</p>
            </div>
            <div data-id="element-10483">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10484">
                {t('pages.ReservationDetail.category')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10485">
                {reservation.room.category}
              </p>
            </div>
          </div>
        </div>
        {/* Guest Information */}
        <div className="p-6 border-b border-gray-200" data-id="element-10486">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10487">
            {t('pages.ReservationDetail.guest_information')}
          </h3>
          <div className="border border-gray-200 rounded-lg p-4" data-id="element-10488">
            <h4 className="text-base font-medium mb-4" data-id="element-10489">
              {reservation.guest.name}
            </h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-10490">
              <div data-id="element-10491">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10492">
                  {t('pages.ReservationDetail.email')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10493">
                  {reservation.guest.email}
                </p>
              </div>
              <div data-id="element-10494">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10495">
                  {t('pages.PropertyInformation.phone_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10496">
                  {reservation.guest.phone}
                </p>
              </div>
              <div data-id="element-10497">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10498">
                  {t('pages.ReservationDetail.passport_number')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10499">
                  {reservation.guest.passport}
                </p>
              </div>
              <div data-id="element-10500">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10501">
                  {t('pages.ReservationDetail.date_of_birth')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10502">
                  {reservation.guest.dateOfBirth}
                </p>
              </div>
              <div data-id="element-10503">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10504">
                  {t('pages.ReservationDetail.nationality')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10505">
                  {reservation.guest.nationality}
                </p>
              </div>
              <div data-id="element-10506">
                <p className="text-sm text-gray-500 mb-1" data-id="element-10507">
                  {t('pages.ReservationDetail.special_requests')}
                </p>
                <p className="text-sm text-gray-900" data-id="element-10508">
                  {reservation.guest.specialRequests || 'None'}
                </p>
              </div>
            </div>
          </div>
        </div>
        {/* Rate Details */}
        <div className="p-6 border-b border-gray-200" data-id="element-10509">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10510">
            {t('pages.ReservationDetail.rate_details')}
          </h3>
          <div className="grid grid-cols-1 gap-4" data-id="element-10511">
            <div data-id="element-10512">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10513">
                {t('pages.ReservationDetail.rate_name')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10514">{reservation.rate.name}</p>
            </div>
            <div data-id="element-10515">
              <p className="text-sm text-gray-500 mb-1" data-id="element-10516">
                {t('components.AddRoomForm.description')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10517">
                {reservation.rate.description}
              </p>
            </div>
          </div>
        </div>
        {/* Price Breakdown */}
        <div className="p-6" data-id="element-10518">
          <h3 className="text-sm font-semibold mb-4" data-id="element-10519">
            {t('pages.ReservationDetail.price_breakdown')}
          </h3>
          <div className="space-y-3" data-id="element-10520">
            <div className="flex justify-between" data-id="element-10521">
              <p className="text-sm text-gray-500" data-id="element-10522">
                {t('pages.ReservationDetail.subtotal')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10523">
                {reservation.price.subtotal}
              </p>
            </div>
            <div className="flex justify-between" data-id="element-10524">
              <p className="text-sm text-gray-500" data-id="element-10525">
                {t('pages.ReservationDetail.service_charge')}
              </p>
              <p className="text-sm text-gray-900" data-id="element-10526">
                {reservation.price.serviceCharge}
              </p>
            </div>
            <div className="border-t border-gray-200 pt-3 flex justify-between" data-id="element-10527">
              <p className="text-sm font-medium" data-id="element-10528">
                {t('pages.ReservationDetail.total')}
              </p>
              <p className="text-sm font-bold" data-id="element-10529">$1.10</p>
            </div>
          </div>
        </div>
      </div>
    </div>;
}